
export default {
  name: 'InputSubmit',
  props: {
    name: {
      type: String,
      default: 'name',
    },
    option: {
      type: String,
      default: 'Option',
    },
    value: {
      type: String,
      default: 'Submit',
    },
    error: {
      type: String,
      default: 'Error',
    },
  },
}
